function menuNavInit() {
  const menuNavContainer = document.querySelector('.menu-nav')

  if (menuNavContainer !== null) {
    const navLinks = menuNavContainer.querySelectorAll('a')

    //this is to offset position when we jump to anchors.
    window.addEventListener('hashchange', () => {
      window.scrollTo(window.scrollX, window.scrollY - 80)
    })

    const config = {
      rootMargin: '-50px 0px -55%'
    }

    let observer = new IntersectionObserver((entries, self) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          toggleActiveLink(entry, navLinks)
        }
      })
    }, config)

    const chickenSection = document.querySelector('.menu-chicken-section')
    observer.observe(chickenSection)
    const menuSections = document.querySelectorAll('.menu-section')
    menuSections.forEach(item => observer.observe(item))
  }
}

function toggleActiveLink(entry, links) {
  const id = entry.target.id
  const target = document.querySelector(`.menu-nav a[href*=${id}]`)

  removeActiveLinks(links)
  target.classList.toggle('active')
}

function removeActiveLinks(links) {
  for (const link of links) {
    link.classList.remove('active')
  }
}

function init() {
  menuNavInit()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/menuNav.js